import React from 'react';
import { useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import FormularioPublico from './pages/FormularioPublico';
import PacientePortal from './pages/PacientePortal';

export default function App() {
  const { user } = useAuth();

  // Ruta pública /formulario — sin necesidad de login
  if (window.location.pathname === '/formulario') {
    return <FormularioPublico />;
  }

  // Ruta pública /pacientes — portal del paciente
  if (window.location.pathname === '/pacientes') {
    return <PacientePortal />;
  }

  return user ? <Dashboard /> : <LoginPage />;
}
